module.exports = __webpack_public_path__ + "img/5.891faee9.jpg";